import { render, staticRenderFns } from "./promote.vue?vue&type=template&id=a5f21008&scoped=true"
import script from "./promote.vue?vue&type=script&lang=js"
export * from "./promote.vue?vue&type=script&lang=js"
import style0 from "./promote.vue?vue&type=style&index=0&id=a5f21008&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f21008",
  null
  
)

export default component.exports